























































import Vue from 'vue'
import TitleName from '../atoms/TitleName.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import NewReturnButton from '../atoms/NewReturnButton.vue'
import NewContentHeaderSectionPdf from '../organisms/NewContentHeaderSectionPdf.vue'
import ContentSectionPdf from '../organisms/ContentSectionPdf.vue'
import { icons } from '@/constants/icons'
import { Contract, Grade } from '@/types/Contract'

type DataType = {
  subjects: Array<{
    name: string
    subject_id: number
  }>
  pngs: Array<string>
  showContent: boolean
  completeFetchPng: boolean
  pageNumber: number
  icons?: Record<string, string>
}

export default Vue.extend({
  components: {
    TitleName,
    ModalPanel,
    NewReturnButton,
    NewContentHeaderSectionPdf,
    ContentSectionPdf
  },

  data(): DataType {
    return {
      showContent: false,
      completeFetchPng: false,
      pageNumber: 0,
      icons: icons,
      subjects: [
        {
          name: '国語',
          subject_id: 1
        },
        {
          name: '算数',
          subject_id: 2
        },
        {
          name: '思考の達人ツール',
          subject_id: 4
        },
        {
          name: '複合教科問題',
          subject_id: 3
        },
        {
          name: '表紙',
          subject_id: 6
        },
        {
          name: 'えい語',
          subject_id: 5
        }
      ],
      pngs: []
    }
  },
  computed: {
    year(): number {
      return this.$store.state.year
    },
    month(): number | null {
      if (!this.$store.state.month) return null
      return this.$store.state.month
    },
    rootPath(): string {
      return process.env.VUE_APP_ROOT_PATH || ''
    },
    newRootPath(): string {
      return process.env.VUE_APP_NEW_ROOT_PATH || ''
    },
    selectedContract(): Contract | null {
      if (!this.year || !this.month) return null
      const selectedMonth = this.year.toString() + ('0' + this.month).slice(-2)
      return (this.$store.state.contracts as Contract[]).find((contract) => contract.month === selectedMonth) || null
    },
    selectedGrade(): Grade | null {
      const contract = this.selectedContract
      return contract ? contract.grade : null
    },
  },
  mounted() {
    // 背景をレンガ調から白に変更
    document.body.style.backgroundImage = 'none'
    document.body.style.backgroundColor = '#ffffff'
  },
  beforeDestroy() {
    // ページ離脱時に背景を元に戻す
    document.body.style.backgroundImage = ''
    document.body.style.backgroundColor = ''
  },
  async created() {
    this.$store.commit('SET_TEXTS', {})

    this.$store.dispatch('getCurrentDate')

    await this.$store.dispatch('getNewTexts')

    const yearMonthValues = Object.entries(this.$store.state.texts).map(([t, ]) => (t))

    const initialDisplayIssue = yearMonthValues.sort((a, b) => Number(b) - Number(a))[0]

    this.$store.commit('SET_MONTH', { month: parseInt(initialDisplayIssue.slice(4)) })
    this.$store.commit('SET_YEAR', { year: parseInt(initialDisplayIssue.slice(0, 4)) })
  },
  methods: {
    openModal(page_number: number): void {
      this.completeFetchPng = false
      this.pageNumber = page_number
      this.showContent = true
    },
    closeModal(): void {
      if (this.completeFetchPng == false) return

      this.pngs = []
      this.showContent = false
    },
    navigateToTop(): void {
      this.$router.push('/new/overseas_downloads')
    }
  },
})
